import React from "react";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import useSmallNav from "../../../../hooks/useSmallNav";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import toyota from "./../../../../assets/info/landcruiser-hero.jpg";
import { popularVehicle } from "../../../../vars/popularVehicles";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";

const ToyotaLandcruiser = () => {
  useSmallNav("Toyota Landcruiser");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Toyota Landcruiser"} bolder />
        <InfoHero image={toyota} />
        <InfoGrid>
          <div>
            <p>
              The Toyota Landcruiser has been around almost as long as Pedders
              have and we're a big fan of the off-road capabilities and total
              reliability of one of the best 4x4s on the road.
            </p>
            <p>
              Pedders have been specialising in producing and testing equipment
              for off-road vehicles for many of our years and are proud to say
              that we believe that we can offer you the very best for your
              Landcruiser.
            </p>
            <p>
              Trak Ryder 4WD Suspension represents many years of technical
              development and delivers new levels of ride and comfort for the
              4-wheel drive Toyota Landcruiser owner. Pedders Trak Ryder
              suspension includes hundreds of quality components in its
              construction each designed to improve the ride and handling of
              specific vehicles in specific ways.
            </p>
            <p>
              There are many different versions of the Landcruiser, starting
              from the 40 up to 200 series, Prado, LWB and SWB. Each Landcruiser
              has it's own suspension design, capabilities and fables and we
              offer many parts to upgrade, lift or simply maintain your
              Landcruiser.
            </p>
            <InfoHeader
              size="smaller"
              text={
                'The first question is "What do I want from my Landcruiser?"'
              }
            />
            <p>
              If you're wanting to put your 4x4 to the test, lift the
              suspension, gain more axle articulation, fit bigger tyres etc,
              check out the "Lift Kits".
            </p>
            <p>
              If you constantly tow or load your Landcruiser, an upgrade in
              standard height or lifted rear suspension will give you a more
              stable vehicle capable of taking more weight without suffering
              from suspension which is unable to control the vehicle.
            </p>
            <p>
              If you are a spirited driver, maybe you want to retain the
              standard height but stiffen everything up to give you more
              feedback, better handling characteristics and control. We cater
              for all.
            </p>
            <p>
              Please choose your vehicle from the selection and should you have
              any questions, feel free to ask us on our Live Chat.
            </p>
            <InfoHeader
              size="smaller"
              text={"How high will my Landcruiser be?"}
            />
            <p>
              Although the kits give an approximate lift, this can be a little
              misleading. Springs settle over time, so a 1.5 inch lift, may turn
              out to be a bit more in reality. To ensure that you know exactly
              what you are getting, we also quote a fitted height. This is
              measured from the bottom of the wheel rim to the wheel-arch. The
              benefit of this method is that tyre choice has no influence on the
              quoted height. A summary of this can be seen here
            </p>
            <p>
              Still not sure we have the right parts? Not sure which kit is the
              one for you? Then please get in touch, where one of our team will
              ensure you get the right parts for your needs.
            </p>
            <iframe
              title={"Landcruiser"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/uKjltW4e6X8"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Toyota")
              .models.find((e) => e.display === "Landcruiser")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <iframe
              title={"Landcruiser1"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/-x9r6VqbGrg"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title={"Landcruiser2"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Toyota" model="Landcruiser" /> */}
      </Container>
    </section>
  );
};

export default ToyotaLandcruiser;
